<div class="federated-modal">
  <div class="modal-content text-center">
    <div class="modal-body">
      <h1 class=" modal-text">Access to your benefits is established through your employer portal.</h1>
      <p class="graylight font-light">Click continue to be redirected.</p>
    </div>
    <div class="pt-3 modal-footer">
      <button name="cancelButton" type="button" aria-label="Close" (click)="close()"
        class="btn btn-block my-1 btn-outline-secondary">Cancel</button>
      <button name="submitButton" type="button" (click)="federatedRedirect()"
        class="btn btn-block my-1 btn-primary">Continue</button>
    </div>
  </div>
</div>